export default "__VITE_ASSET__1337a964__"